<div class="gn-flex gn-flex-col gn-h-full gn-justify-between">
  <div class="md:gn-p-5 gn-p-2">
    @for (group of form.controls; track group; let isLast = $last; let i = $index) {
      <div class="w-full" [ngClass]="!isLast ? 'gn-mb-5 gn-pb-5 gn-border-gray-300 gn-border-b-2' : ''">
        <app-voucher
          [form]="group"
          [vouchers]="form"
          [company]="company"
          [currencySymbol]="currency"
          [currency]="$safeNavigationMigration(company?.currency)"
          [index]="i"
          [brandId]="brandId"
          [promocode]="promocode"
          (deleted)="deleted.emit(i)"
          #voucherEl
        ></app-voucher>
      </div>
    }
    @if (!form || !form.length) {
      <p class="gn-text-gray-400 gn-text-center">{{ 'basket.empty' | translate }}</p>
    }
  </div>
  <div class="wrapper">
    <!--
    <form class="test gn-w-full gn-p-5 gn-bg-gray-200 gn-text-gray-700 sm:gn-grid md:gn-flex gn-justify-between" (ngSubmit)="addVoucher()">
      <div class="gn-flex">
        <p class="gn-text-xs gn-mr-2 gn-self-center">{{ 'basket.add' | translate }}</p>
        <div class="gn-flex gn-mr-2 gn-border gn-border-gray-500 gn-rounded">
          <button type="button" (click)="editVoucherValue(-company.voucher_config.step)" class="gn-px-3 gn-text-lg gn-text-gray-700 gn-font-medium gn-bg-gray-200 hover:gn-bg-gray-400 gn-flex gn-items-center gn-justify-center">
            <span>-</span>
          </button>
          <input [formControl]="amount" [prefix]="currency" mask="0*" class="input gn-bg-white gn-rounded-none gn-w-24 sm:gn-w-20 gn-border-0" type="text" placeholder="Amount" />
          <button type="button" (click)="editVoucherValue(company.voucher_config.step)" class="gn-px-3 gn-text-lg gn-text-gray-700 gn-font-medium gn-bg-gray-200 hover:gn-bg-gray-400 gn-flex gn-items-center gn-justify-center">
            <span>+</span>
          </button>
        </div>
        <button type="submit" class="gn-text-white gn-bg-main gn-px-4 gn-py-2 gn-rounded">
          <fa-icon [icon]="faGiftCard"></fa-icon> {{ 'buttons.add' | translate }}
        </button>
      </div>
      -->
      <!--div *ngIf="!showCurrency"  class="gn-flex gn-bg-gray-200 gn-justify-center gn-place-items-end">
      <button (click)="showCurrency=true" class="gn-rounded gn-text-xs gn-mr-2 gn-self-center gn-self-center gn-ml-4 gn-border-2 gn-border-gray-500 gn-p-2 gn-bg-white">Wrong currency ?</button>
    </div-->
    <!--
    </form>
    -->
    @if (company?.company_id == '2' && brandId == '4696') {
    <div class="test gn-w-full md:gn-px-5 gn-px-2 gn-text-gray-700">
      <div class="gn-w-full gn-flex gn-flex-col gn-py-8 gn-border-t-2 gn-border-gray-300">
        <p class="gn-font-medium gn-text-lg gn-w-full gn-text-left gn-mb-2">Check out our recommended vouchers</p>
        <div class="gn-flex gn-gap-4 gn-overflow-x-scroll gn-pb-2 .gn-scroll-btn-hide">
          @for(rec of recVouchers ; track rec){
            <div class="gn-flex gn-flex-col gn-justify-between gn-bg-white gn-gap-2 gn-p-4 gn-border gn-border-gray-400 gn-rounded-xl gn-flex-shrink-0 md:gn-w-2/5 gn-w-5/6">
              <div class="gn-flex gn-flex-col gn-gap-2">
                <p class="gn-text-xl gn-font-bold">{{ rec.name }}</p>
                <p class="gn-text-sm">{{ rec.desc }}*</p>
              </div>
              @if(!rec.added){
              <div class="gn-flex gn-flex-col gn-gap-2">
                <p class="gn-font-semibold gn-text-xl">{{ currency }}{{ rec.price }}</p>
                <button 
                  type="button" 
                  class="gn-font-bold gn-text-white gn-uppercase gn-text-center gn-bg-main gn-px-4 gn-py-2 gn-border gn-border-main gn-rounded-lg hover:gn-bg-white hover:gn-text-main gn-transition"
                  (click)="addRecVoucher(rec.price, rec.actId, $safeNavigationMigration(company?.currency), rec.recId)">
                  Add to cart
                </button>
              </div>
              }
              @if(rec.added){
                <div class="gn-flex gn-flex-col">
                  <p class="gn-text-lg gn-font-medium gn-text-left">Success!</p> 
                  <p class="gn-text-md gn-text-left">Your voucher has been added — personalise it to create the perfect gift.</p>
                </div>
              }
            </div>
          }
        </div>
        <p class="gn-text-xs gn-w-full gn-text-left gn-mt-2">*Recommended values are indicative only. Vouchers are monetary value and can be redeemed for, or towards, any of our 110+ experiences. Prices vary by location, and some activities may have certain booking requirements to keep in mind.</p>
      </div>
    </div>
    } 
    @if (true || company?.company_id != '2') {
    <form class="test gn-w-full md:gn-px-5 gn-px-2 gn-text-gray-700" (ngSubmit)="addVoucher()">
      <div class="gn-w-full gn-flex gn-flex-col gn-gap-2 gn-py-8 gn-border-b-2 gn-border-t-2 gn-border-gray-300">
        @if (company?.company_id == '2' && brandId == '4696') {
        <p class="gn-text-lg gn-font-medium gn-text-left">Or add a custom priced voucher</p>
        }@else{
          <p class="gn-text-lg gn-font-medium gn-text-left">{{ 'basket.add' | translate }}</p>
        }
        <div class="gn-flex gn-flex-row gn-space-between">
          <div class="gn-flex gn-mr-2 gn-border gn-border-gray-500 gn-rounded">
            <button type="button" (click)="editVoucherValue(-company.voucher_config.step)" class="gn-px-3 gn-text-lg gn-text-gray-700 gn-font-medium gn-bg-gray-200 hover:gn-bg-gray-400 gn-flex gn-items-center gn-justify-center">
              <span>-</span>
            </button>
            <input [formControl]="amount" [prefix]="currency" mask="0*" class="input gn-font-semibold gn-text-center gn-bg-white gn-rounded-none gn-w-24 sm:gn-w-20 gn-border-0" type="text" placeholder="Amount" />
            <button type="button" (click)="editVoucherValue(company.voucher_config.step)" class="gn-px-3 gn-text-lg gn-text-gray-700 gn-font-medium gn-bg-gray-200 hover:gn-bg-gray-400 gn-flex gn-items-center gn-justify-center">
              <span>+</span>
            </button>
          </div>
          @if(!voucherAdded){
          <button type="submit" class="gn-font-bold gn-text-white gn-bg-main gn-px-4 gn-py-2 gn-border gn-border-main gn-rounded gn-uppercase hover:gn-bg-white hover:gn-text-main gn-transition">
            <!--{{ 'buttons.add' | translate }}-->
             Add To Cart
          </button>
          }
          @if(voucherAdded){
            <div class="gn-flex gn-flex-col">
              <p class="gn-text-lg gn-font-medium gn-text-left">Success!</p> 
              <p class="gn-text-md gn-text-left">Your voucher has been added — personalise it to create the perfect gift.</p>
            </div>
          }
        </div>
      </div>
    </form>
  }


    <div class="md:gn-p-5 gn-p-2 gn-flex gn-justify-end">
      <div class="gn-w-full">
        <p class="gn-font-medium gn-text-lg">Order Summary</p>
        <div class="gn-flex gn-items-start gn-pb-4 gn-justify-between gn-w-full gn-text-gray-700 gn-border-b gn-border-gray-300">
          <div class="gn-mt-2 gn-text-left">
            <p class="gn-text-sm">{{ 'totals.voucher_total' | translate }}</p>
            <p class="gn-text-sm">{{ 'totals.wrapping' | translate  }}</p>
            <p class="gn-text-sm">{{ 'totals.delivery' | translate }}</p>
            <!--p class="gn-text-sm">{{ 'Extras' | translate }}</p-->
            <p class="gn-mt-2 gn-font-medium gn-text-lg gn-uppercase">{{ 'totals.total' | translate }}</p>
            @if (totalPaid > 0) {
              <p class="gn-text-sm gn-mt-2">{{ 'Paid' | translate }}</p>
            }
            @if (totalOwed !== total && totalOwed > 0) {
              <p class="gn-mt-2 gn-font-medium gn-text-lg gn-uppercase">{{ 'Due' | translate }}</p>
            }
          </div>
          <div class="gn-mr-2 gn-text-right">
            <p class="gn-text-sm">{{ totalVouchers | currency:$safeNavigationMigration(company?.currency):'symbol-narrow' }}</p>
            <p class="gn-text-sm">{{ totalWrapping | currency:$safeNavigationMigration(company?.currency):'symbol-narrow' }}</p>
            <p class="gn-text-sm">{{ totalDelivery | currency:$safeNavigationMigration(company?.currency):'symbol-narrow' }}</p>
            <!--p class="gn-text-sm">{{ totalExtras | currency:company?.currency:'symbol-narrow' }}</p-->
            <p class="gn-mt-2 gn-font-medium gn-text-lg gn-uppercase">{{ total | currency:$safeNavigationMigration(company?.currency):'symbol-narrow' }}</p>
            @if (totalPaid > 0) {
              <p class="gn-text-sm gn-mt-2">{{ totalPaid | currency:$safeNavigationMigration(company?.currency):'symbol-narrow' }}</p>
            }
            @if (totalOwed !== total && totalOwed > 0) {
              <p class="gn-mt-2 gn-font-medium gn-text-lg gn-uppercase">{{ totalOwed | currency:$safeNavigationMigration(company?.currency):'symbol-narrow' }}</p>
            }
          </div>
        </div>
        @if (company?.company_id == '2') {
        <div class="gn-flex gn-justify-between gn-place-items-end gn-py-4">
          <p class="gn-font-medium gn-text-lg gn-self-center">Currency</p>
          <ng-select [(ngModel)]="newCurrency" [ngModelOptions]="{standalone: true}" [clearable]="false" (change)="changeCurrency($event)" class="gn-text-sm gn-w-24">
            @for (curr of currencies ; track curr) {
              <ng-option [value]="curr">{{curr}}
              </ng-option>
            }
          </ng-select>
        </div>
        }
      </div>
      @if (confirmMissingPersonalization) {
        <div class=" gn-fixed gn-p-2 gn-bg-overlay gn-top-0 gn-right-0 gn-flex gn-w-full gn-h-full" (click)="confirmMissingPersonalization = false;" style="z-index:1000; max-width:900px;">
          <div class="confirm_overlay gn-text-black gn-text-lg gn-opacity-100 gn-my-auto gn-mx-auto gn-p-5 gn-border-2 gn-border-gray-500 gn-rounded ">
            <div>
              <h3 class="gn-text-center">Some vouchers do not have a personalised message or a recipient name. Continue anyway ?</h3>
            </div>
            <div>
              <p class="gn-flex gn-items-center  gn-justify-center">
                <a class="gn-mx-4" (click)="confirmMissingPersonalization = false; ">
                  <button class="gn-text-white gn-bg-gray-400 gn-px-5 gn-py-2 gn-rounded gn-mt-4 gn-text-xl">No</button>
                </a>
                <a class="gn-mx-4" (click)="confirmMissingPersonalization = false; ignoreMissingPersonalization = true; validate()">
                  <button  class="gn-text-white gn-bg-green-500 gn-px-5 gn-py-2 gn-rounded gn-mt-4 gn-text-xl" >Yes</button>
                </a>
              </p>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  <!-- Paymnent button -->
  <div
    id="proceedBtn"
    style="position:sticky; bottom:0;"
    [style.box-shadow]="totalOwed ? '0 -2px 4px rgba(0,0,0,0.20)' : null"
    class="gn-p-4 gn-bg-gray-50">
    <!-- contents -->
    @if (acceptPayments && form.length > 0) {
    <div class="gn-w-full gn-flex gn-flex-row gn-gap-6">
        @if (totalOwed) {
          <div class="gn-flex gn-flex-col">
            <p class="gn-text-sm">Total</p>
            <p class="gn-font-medium gn-text-lg gn-uppercase">{{ totalOwed | currency:$safeNavigationMigration(company?.currency):'symbol-narrow' }}</p>
          </div>
        }
      <button type="button" (click)="validate()" class="gn-font-bold gn-text-center gn-uppercase gn-w-full gn-text-white gn-bg-main gn-px-5 gn-py-2 gn-rounded gn-text-md md:gn-text-lg gn-border gn-border-main gn-rounded-lg hover:gn-bg-white hover:gn-text-main gn-transition">
        <!--{{ 'buttons.pay_now' | translate }}-->
        Proceed To Payment
      </button>
    </div>
    }
  </div>
  <!-- Payment button end -->
  <div class="gn-p-5 gn-bg-gray-200 gn-flex gn-items-center gn-justify-between">
    <div class="gn-flex gn-items-center">
      <img class="gn-object-cover gn-h-10 gn-w-10 gn-mr-2" src="https://images.rezbot.com/widgets/assets/visa.svg" />
      <img class="gn-object-cover gn-h-10 gn-w-10 gn-mr-2" src="https://images.rezbot.com/widgets/assets/master-card.svg" />
      <img class="gn-object-cover gn-h-10 gn-w-10 gn-mr-2" src="https://images.rezbot.com/widgets/assets/american-express.svg" />
      <img class="gn-object-cover gn-h-10 gn-w-10" src="https://images.rezbot.com/widgets/assets/paypal.svg" />
    </div>
    <img class="gn-h-10" src="https://images.rezbot.com/widgets/assets/stripe.png" style="filter: invert(0.8);" />
  </div>
</div>
